import { useUIStateStore } from "@/store/uiStateStore";

function Hr(props) {
  const { className } = props;

  const isTunecore = useUIStateStore(state => state.isTunecore);

  return (
    <div className={`${className} w-full ${isTunecore ? "border-tunecore-light-grey" : "border-sentric-rebrand-mid-grey"} border-b`} />
  );
}

export default Hr;
